
import React, { useEffect } from "react"

import useObtenerTraducciones from "../js/translations/useObtenerTraducciones";

/**
 * Componente de popup de sin conexión, este componente se muestra cuando se ha ido la conexión a internet y el usuario no está logueado y tampoco tiene el pwa habilitado desde el admin.
 * 
 * @returns {JSX.Element} Componente SinConexionPopup.
 */
export const SinConexionPopup = () => {
    const { isReady, textosSeccion: textoConexion } = useObtenerTraducciones('sin_conexion');

    return (
        <>
            {
                isReady  && 
                <section className="sin-conexion-popup" role="alert" aria-live="assertive">
                    <div className="window">
                        <img aria-hidden="true" alt="Blop sin conexión" className="image" src="/img/sinconexion-image.png" />
                        <h1 className="title">{textoConexion?.sin_conexion || 'Sin conexión'}</h1>
                        <p className="description">{textoConexion?.descripcion || 'Conéctate para explorar más de 400 libros de las  mejores editoriales de Latinoamérica'}</p>
                    </div>

                </section>
            }

        </>
    )
}